import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { withRetry } from 'ml-services-common-react';

const sendWithRetry = (endpoint, method, params, additionalHeaders) => withRetry(() => JsonRPCService.send(endpoint, method, params, additionalHeaders));

export default class AccountService {
    static getPotentialExistingAccounts(accountSearchCritera, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getPotentialExistingAccounts', [accountSearchCritera], additionalHeaders);
    }

    static getAccountDetails(accountNumber, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getAccountDetails', [accountNumber], additionalHeaders);
    }

    static getAccountBillingData(accountNumber, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getAccountBillingData', [accountNumber], additionalHeaders);
    }

    static addRecentlyViewedAccounts(accountNumber, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'addRecentlyViewedAccounts', [accountNumber], additionalHeaders);
    }

    static getRecentlyViewedAccounts(additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getRecentlyViewedAccounts', [], additionalHeaders);
    }

    static getAvailableProductsForAccount(newSubmission, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getAvailableProductsForAccount', [newSubmission], additionalHeaders);
    }

    static getAccountClaims(accountNumber, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getAccountClaims', [accountNumber], additionalHeaders);
    }

    static getAccountsForCurrentUser(
        createdInLastXDays, queryOptions, queryParameters, additionalHeaders = {}
    ) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getAccountsForCurrentUser', [createdInLastXDays, queryOptions, queryParameters], additionalHeaders);
    }

    static getPersonalAccountsForCurrentUser(
        createdInLastXDays, queryOptions, queryParameters, additionalHeaders = {}
    ) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getPersonalAccountsForCurrentUser', [createdInLastXDays, queryOptions, queryParameters], additionalHeaders);
    }

    static getCommercialAccountsForCurrentUser(
        createdInLastXDays, queryOptions, queryParameters, additionalHeaders = {}
    ) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getCommercialAccountsForCurrentUser', [createdInLastXDays, queryOptions, queryParameters], additionalHeaders);
    }

    static getAccountsForProducerCode(
        createdInLastXDays, queryOptions, queryParameters, additionalHeaders = {}
    ) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getAccountsForProducerCode', [createdInLastXDays, queryOptions, queryParameters], additionalHeaders);
    }

    static getPersonalAccountsForProducerCode(
        createdInLastXDays, queryOptions, queryParameters, additionalHeaders = {}
    ) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getPersonalAccountsForProducerCode', [createdInLastXDays, queryOptions, queryParameters], additionalHeaders);
    }

    static getCommercialAccountsForProducerCode(
        createdInLastXDays, queryOptions, queryParameters, additionalHeaders = {}
    ) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getCommercialAccountsForProducerCode', [createdInLastXDays, queryOptions, queryParameters], additionalHeaders);
    }

    static getOpenPolicyTransactionsForAccount(accountNumber, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getOpenPolicyTransactionsForAccount', [accountNumber], additionalHeaders);
    }

    static getOrCreateAccount(account, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getOrCreateAccount', [account], additionalHeaders);
    }

    static getAccountJobsSummariesForCurrentUser(createdInLastXDays, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getAccountJobsSummariesForCurrentUser', [createdInLastXDays], additionalHeaders);
    }

    static updateAccountDetails(accountNumber, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'updateAccountDetails', [accountNumber], additionalHeaders);
    }

    static getAccountJobsForCurrentUser(noOfDays, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getAccountJobsForCurrentUser', [noOfDays], additionalHeaders);
    }

    static getNamedInsuredCandidatesML(accountNumber, productCode, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getNamedInsuredCandidatesML', [accountNumber, productCode], additionalHeaders);
    }

    static getLimitedPoliciesClaimsForCurrentUser(createdInLastXDays, limit, searchRequest, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getLimitedPoliciesClaimsForCurrentUser',
            [createdInLastXDays, limit, searchRequest],
            additionalHeaders);
    }

    static searchByARSPoliciesML(searchRequest, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'searchByARSPoliciesML', [searchRequest], additionalHeaders);
    }

    static updateAccountHolderContactDetails(accountNumber, accountHolderContactDetails, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'updateContact', [accountNumber, accountHolderContactDetails], additionalHeaders);
    }
    
    static getPendingPolicyChangesForAccount (accountNumber, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getPendingPolicyChangesForAccount', [accountNumber], additionalHeaders);
    }

    static getPolicyDocumentsForAccount (accountNumber, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'getPolicyDocumentsForAccount', [accountNumber], additionalHeaders);
    }

    static shareSelectedDocuments (docsToShare, accountNumber, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'shareSelectedDocuments', [docsToShare, accountNumber], additionalHeaders);
    }

    static canEditCommunicationsFields(accountNumber, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'canEditCommunicationsFields', [accountNumber], additionalHeaders);
    }

    static checkEmailVerified_Ext(account, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayAccount'),
            'checkEmailVerified_Ext', [account], additionalHeaders);
    }
}
